import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';

export const hasRecoveryEmailSentAccess: CanMatchFn = (): boolean | UrlTree => {
  const loginRecoveryFacade = inject(LoginRecoveryFacade);
  const router = inject(Router);

  if (loginRecoveryFacade.recoveryCredentials()) {
    return true;
  }

  return router.createUrlTree([ApplicationPath.CannotLogin]);
};
